import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  getAssignedSensorsByCurrentUser,
  postMapShapes,
  postMapBackground,
} from '../../../../../api';
import lookupApi from '../../../../../api/lookup';
import helper from '../../../../../utils/helper';
import CUMap from '../CUMap';

const NewMap = (props) => {
  const history = useHistory();
  const { deptId } = helper.parseQueryString(props.location.search);
  const [sensors, setSensors] = React.useState([]);
  const [errors, setErrors] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);
  const [state, setState] = React.useState({
    sensors: [],
    errors: '',
  });
  const [groups, setGroups] = React.useState([]);

  React.useEffect(() => {
    setLoading(true);
    getAssignedSensorsByCurrentUser()
      .then((resp) => setState({ ...state, sensors: resp }))
      .catch((err) => setState({ ...state, errors: err }));
    lookupApi
      .getGroups()
      .then((resp) => setGroups(resp.items))
      .catch((err) => setErrors(err));
    setLoading(false);
  }, []);
  function onCreateMap(values) {
    const mapShapes = {
      name: values.name,
      ...values.shapes,
    };

    setSubmitting(true);
    Promise.all([
      values.bgFile
        ? postMapBackground(deptId, values.name, values.bgFile)
        : Promise.resolve(),
      postMapShapes(deptId, values.name, mapShapes),
    ])
      .then(() => history.goBack())
      .catch((err) => setSubmitting(false));
  }
  return (
    <CUMap
      {...state}
      submitting={submitting}
      groups={groups}
      onCreateMap={onCreateMap}
      onBack={() => history.goBack()}
    />
  );
};

export default NewMap;
